import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton = ({ onBeforeLogout }) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    // Set sidebar state to 'logout' before actual logout
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem('sidebarState', 'logout');
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const handleClick = () => {
    // If onBeforeLogout is provided and returns false, don't proceed
    if (onBeforeLogout) {
      const shouldProceed = onBeforeLogout(handleLogout);
      if (shouldProceed === false) {
        return; // Don't logout, confirmation dialog will handle it
      }
    }
    handleLogout();
  };

  return (
    <button onClick={handleClick} className="flex items-center w-full cursor-pointer">
      Log out
    </button>
  );
};

export default LogoutButton;